import api from './api'

// Same endpoints as the user site (frontend/src/apiservices/casinoService.js).
// Upstream provider can take 15s+ on a cold cache, so these override the
// global 10s axios timeout.
const CASINO_TIMEOUT = 30000

export const getCasinoGameDetails = (type, signal) =>
  api.post('/casino/casino/all-data', { type, data: {} }, { signal, timeout: CASINO_TIMEOUT }).then((r) => r.data)

export const getMyBets = (userId, matchId, signal) =>
  api.post('/casino/casino/mybets', { user_id: userId, match_id: matchId }, { signal, timeout: CASINO_TIMEOUT }).then((r) => r.data)

// SuperOver two-innings scorecard held by the server poller (public, like all-data).
export const getSuperOverScorecard = (type, signal) =>
  api.post('/casino/casino/superover-scorecard', { type }, { signal, timeout: CASINO_TIMEOUT }).then((r) => r.data)

export const getLastResults = (type, signal) =>
  api.post('/casino/casino/last-results', { type }, { signal, timeout: CASINO_TIMEOUT }).then((r) => r.data)

export const getDetailResults = (type, mid, signal) =>
  api.post('/casino/casino/detail-results', { type, mid }, { signal, timeout: CASINO_TIMEOUT }).then((r) => r.data)

// Admin downline bets (server/d99/routes/betList.routes.js — auth + downline
// filter + username join). gameName matches cb.game_name/cb.type (ILIKE).
export const getCasinoOpenBets = (gameName, signal) =>
  api.get(`/d99/bet-list/casino/open-downline${gameName ? `?gameName=${encodeURIComponent(gameName)}` : ''}`, { signal }).then((r) => r.data)

export const getCasinoAllBets = (gameName, signal) =>
  api.get(`/d99/bet-list/casino/all-downline${gameName ? `?gameName=${encodeURIComponent(gameName)}` : ''}`, { signal }).then((r) => r.data)

// Result modal: the logged-in admin's downline bets on one round, with Win /
// Deleted computed server-side (server/services/admin/casinoRoundBetsService.js).
export const getCasinoRoundBets = (gameName, roundId, signal) =>
  api.get('/admin/reports/casino/round-bets', { params: { gameName, roundId }, signal }).then((r) => r.data)

const DEFAULT_CASINO_BUTTONS = [25, 50, 100, 200, 500, 1000]

export const getStakeButtonValues = async () => DEFAULT_CASINO_BUTTONS
